import React from 'react'

function About() {
    return (
        <div className="about-me" id="about">
            <h6 id="greeting">Hello! my name is</h6>
            <h3 id="name">Saim Rizvi</h3>
            <p className="about-info">I am an aspiring software engineer with a passion for technology and a relentless drive to learn and innovate. Although my academic background is not in computer science, I have dedicated myself to mastering the skills necessary to excel in the field of software engineering.</p>
            <p className="about-info">My journey began with self-directed learning, where I took numerous online courses and completed several projects to build a solid foundation in programming. I have gained proficiency in languages such as Python, Java, and JavaScript, and have become comfortable working with frameworks like React. Through hands-on projects, I have developed strong problem-solving abilities and an understanding of software development best practices. My commitment to continuous learning and professional growth drives me to stay updated with the latest industry trends and technologies. I am excited about the opportunity to bring my diverse background and passion for software engineering to a dynamic team where I can make a meaningful impact.</p>
            <p className="about-info">Here are few technologies I've been working with recently:</p>
            <ul className="skills">
                <li className="skill-list">JavaScript (ES6+)</li>
                <li className="skill-list">Java</li>
                <li className="skill-list">Microservices</li>
                <li className="skill-list">JUnit5</li>
                <li className="skill-list">CI/CD</li>
                <li className="skill-list">Linux</li>
            </ul>
            <div className="hr">
                <hr  />
            </div>
        </div>
    )
}

export default About
